import Service from '../Service'
import {http} from '../config'

export default class InformativoService extends Service{

    constructor(){
        super('informativo');
    }

    EnviarAgora(){
        return http.post(`${this._nomeControle}/EnviarAgora`);
    }

}